import theme from '../../../../theme';

const styles = (theme) => ({
  root: {},
  show: {
    display: 'block',
  },
  hide: {
    display: 'none',
  },
  button: {
    borderWidth: '1px',
    borderColor: theme.palette.primary.dark,
    borderStyle: 'solid',
    borderRadius: 0,
    color: theme.palette.text.dark,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.text.white,
    },
    '&:first-of-type': {
      borderRadius: '5px 0 0 5px',
    },
    '&:last-of-type': {
      borderRadius: '0 5px 5px 0',
    },
    padding: '4px 30px',
    [theme.breakpoints.up('sm')]: {
      padding: '4px 60px',
    },
    '&:disabled': {
      color: theme.palette.text.dark,
    },
  },
  buttonActive: {
    backgroundColor: theme.palette.primary.dark,
    color: theme.palette.text.white,
    '&:disabled': {
      color: theme.palette.text.white,
    },
  },
  question: {
    fontWeight: 600,
  },
  answersHeading: {
    fontSize: '1.25rem',
    fontWeight: 600,
  },
  result: {
    fontSize: '1.25rem',
    fontWeight: 600,
  },
  step: {
    borderWidth: '1px',
    borderColor: theme.palette.primary.dark,
    borderStyle: 'solid',
    display: 'inline-flex',
    flexGrow: 1,
  },
  completeStep: {
    backgroundColor: theme.palette.primary.dark,
  },
  stepWrapper: {
    display: 'flex',
  },
  stepLabel: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    flexGrow: 1,
  },
  additional: {
    marginTop: 0,
  },
  buttons: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  checkboxLabel: {
    width: '100%',
  },
  link: {
    color: theme.palette.primary.dark,
    textDecoration: 'none',
  },
  textarea: {
    width: '100%',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: theme.palette.border.light,
    padding: '12px',
  },
  center: {
    textAlign: 'center',
  },
  container: {
    width: '100%',
    border: `1px solid ${theme.palette.border.light}`,
    padding: '10px',
  },
  icon: {
    color: theme.palette.secondary.main,
  },
  iconWrapper: {
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: theme.palette.border.lighter,
    borderRadius: '100px',
    padding: '10px 10px 3px 10px',
    boxSizing: 'content-box',
  },
  mainHeading: {
    fontSize: '1.25rem',
    display: 'flex',
    alignItems: 'center',
    paddingBottom: '10px',
    marginBottom: '10px',
    borderBottom: `2px solid ${theme.palette.border.lighter}`,
  },
  label: {
    marginLeft: '12px',
    marginTop: '-8px',
    fontSize: '1.375rem !important',
    '&.shrink': {
      /* Shrink overrides are not straight forward (see https://github.com/mui-org/material-ui/issues/15918) */
      transform: 'translate(0px, 0px) scale(0.8889)',
      backgroundColor: theme.palette.text.white,
      paddingRight: theme.spacing.unit * 0.75,
    },
  },
  exclamation: {
    width: '70px',
    height: '70px',
    color: '#F75C58',
  },
  answerButtons: {
    display: 'flex',
    alignItems: 'center',
  },
});

export default styles;
